import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useRestApi } from "@/context/api";
import { useCurrentCompany } from "@/context/auth";

import { queryKeys } from "./queryKeys";

export const useTeamTreeQuery = () => {
  const { teamTree } = useRestApi();
  const currentCompany = useCurrentCompany();

  return useQuery({
    queryKey: [queryKeys.TEAM_TREE, currentCompany.id],
    queryFn: () => teamTree.getTeamTree(currentCompany.id),
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
};

export const useTeamDetailsQuery = (teamId: string | null) => {
  const { teamTree } = useRestApi();
  const currentCompany = useCurrentCompany();

  return useQuery({
    queryKey: [queryKeys.TEAM_TREE_DETAILS, currentCompany.id, teamId],
    queryFn: () => teamTree.getTeamTreeDetails(currentCompany.id, teamId!),
    enabled: !!teamId,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
};

export const useTeamMembersQuery = (
  teamId: string | null,
  page: number,
  size: number,
  search?: string,
) => {
  const { teamTree } = useRestApi();
  const currentCompany = useCurrentCompany();

  return useQuery({
    queryKey: [queryKeys.TEAM_TREE_MEMBERS, currentCompany.id, teamId, page, size, search],
    queryFn: () =>
      teamTree.getTeamTreeMembers(currentCompany.id, teamId!, {
        page,
        size,
        search: search || undefined,
      }),
    enabled: !!teamId,
    staleTime: 30 * 1000,
    placeholderData: keepPreviousData,
  });
};
